module.exports = __webpack_public_path__ + "static/media/handshake.4bba16fa.svg";